import axios from 'axios'
import { url } from '@js/utilities/url.js'
import { errorNotify } from '@js/utilities/bugsnag.js'

/**
 * Get a valid live campaign status
 *
 * @param {string} campaignCode
 * @returns object|null
 */
async function fetchCampaignInfo(campaignCode) {
    try {
        const response = await axios.get(url('/api/campaign-info?campaign_code=' + campaignCode))

        if (response?.status !== 200 || !response?.data?.campaign_type) {
            errorNotify('Failed Campaign Status network request', 'error', 'Campaign Status', { data: response })
            return null
        }

        window.CAMPAIGN_TYPE = response.data?.campaign_type
        window.CAMPAIGN_INTEGRATION = response.data?.campaign_integration

        return response.data
    } catch (error) {
        errorNotify('Failed Campaign Status network request', 'error', 'Campaign Status', { error })
        return null
    }
}

export { fetchCampaignInfo }
